var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Briefcase",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Briefcase",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3a2 2 0 012-2h4a2 2 0 012 2v1h3a1 1 0 011 1v9a1 1 0 01-1 1H1a1 1 0 01-1-1V5a1 1 0 011-1h3V3zm6 0v1H6V3h4zm-8 7v3h12v-3h-4a1 1 0 01-1 1H7a1 1 0 01-1-1H2zm8-2h4V6H2v2h4a1 1 0 011-1h2a1 1 0 011 1z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgJobsIcon;